"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.debounce")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _MembersTab = _interopRequireDefault(require("./MembersTab")),
    _AddUsersTab = _interopRequireDefault(require("./AddUsersTab")),
    _AddTeamsTab = _interopRequireDefault(require("./AddTeamsTab"));

require("../styles/_collaboration-modal.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function itemMatchesFilter(item, filter) {
  return Object.values(item).some(function (itemField) {
    return itemField && "string" == typeof itemField && itemField.toLowerCase().includes(filter.toLowerCase());
  });
}

var CollaborationModal = function (_Component) {
  function CollaborationModal(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, CollaborationModal), _this = _super.call(this, props), _this.onSearchChange = (0, _lodash["default"])(function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(_ref) {
        var value, selectedTabIndex, _this$props, getUsersByName, getTeamsByName, organisationId, _ref3, data, error;

        return _regenerator["default"].wrap(function (_context) {
          for (;;) {
            switch (_context.prev = _context.next) {
              case 0:
                if (value = _ref.target.value, value) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (_this.setState({
                  loading: !0
                }), selectedTabIndex = _this.state.selectedTabIndex, _this$props = _this.props, getUsersByName = _this$props.getUsersByName, getTeamsByName = _this$props.getTeamsByName, organisationId = _this$props.organisationId, 1 !== selectedTabIndex) {
                  _context.next = 12;
                  break;
                }

                return _context.next = 9, getUsersByName({
                  name: value,
                  organisationId: organisationId
                });

              case 9:
                _context.t0 = _context.sent, _context.next = 15;
                break;

              case 12:
                return _context.next = 14, getTeamsByName({
                  name: value,
                  organisationId: organisationId
                });

              case 14:
                _context.t0 = _context.sent;

              case 15:
                if (_ref3 = _context.t0, data = _ref3.data, error = _ref3.error, data && !error) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  loading: !1
                }));

              case 20:
                _this.setState({
                  users: data.getUsersByName,
                  teams: data.getTeamsByName,
                  loading: !1
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), 250), _this.filterByName = (0, _memoizeOne["default"])(function (filter, list) {
      return list.filter(function (item) {
        return itemMatchesFilter(item, filter);
      });
    }, function (_ref4, _ref5) {
      var _ref6 = (0, _slicedToArray2["default"])(_ref4, 2),
          newFilter = _ref6[0],
          newList = _ref6[1],
          _ref7 = (0, _slicedToArray2["default"])(_ref5, 2),
          oldFilter = _ref7[0],
          oldList = _ref7[1];

      return newFilter === oldFilter && newList === oldList;
    }), _this.updateSelectedTabIndex = function (_ref8) {
      var selectedTabIndex = _ref8.selectedTabIndex;
      _this.setState({
        selectedTabIndex: selectedTabIndex,
        filter: "",
        users: void 0,
        teams: void 0,
        loading: !1
      }), _this._searchInputRef && _this._searchInputRef.clearValue();
    }, _this.handleInputChange = function (_ref9) {
      var value = _ref9.target.value;

      _this.setState({
        filter: value
      });
    }, _this.setSearchInputRef = function (ref) {
      _this._searchInputRef || !ref || (_this._searchInputRef = ref);
    }, _this.state = {
      teams: void 0,
      users: void 0,
      loading: !1,
      selectedTabIndex: 0,
      filter: ""
    }, _this;
  }

  (0, _inherits2["default"])(CollaborationModal, _Component);

  var _super = _createSuper(CollaborationModal);

  return (0, _createClass2["default"])(CollaborationModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          members = _this$props2.members,
          onUpdateAndSaveMembers = _this$props2.onUpdateAndSaveMembers,
          onClose = _this$props2.onClose,
          onRemoveMember = _this$props2.onRemoveMember,
          onUpdateMember = _this$props2.onUpdateMember,
          onAddMember = _this$props2.onAddMember,
          visible = _this$props2.visible,
          roles = _this$props2.roles,
          _this$state = this.state,
          selectedTabIndex = _this$state.selectedTabIndex,
          users = _this$state.users,
          teams = _this$state.teams,
          filter = _this$state.filter,
          loading = _this$state.loading,
          filteredMembers = filter ? this.filterByName(filter, members) : members || [],
          membersIds = members ? members.map(function (_ref10) {
        var userId = _ref10.userId,
            teamId = _ref10.teamId;
        return userId || teamId;
      }) : [];
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("collaboration-modal", {
          "collaboration-modal--loading": loading
        })
      }, _react["default"].createElement(_uiKit.FormModal, {
        visible: visible,
        onClose: onClose,
        saveText: "SAVE CHANGES",
        onSave: onUpdateAndSaveMembers
      }, _react["default"].createElement("div", {
        className: "collaboration-modal__header"
      }, _react["default"].createElement("h1", {
        className: "collaboration-modal__header__title"
      }, "Manage Collaborators"), _react["default"].createElement("p", {
        className: "collaboration-modal__header__sub-title"
      }, "Choose who you want to collaborate with you")), _react["default"].createElement("div", {
        className: "collaboration-modal__body"
      }, _react["default"].createElement(_uiKit.Input, {
        ref: this.setSearchInputRef,
        className: "collaboration-modal__search",
        prefix: "search",
        placeholder: "Search",
        value: filter,
        onChange: 0 === selectedTabIndex ? this.handleInputChange : this.onSearchChange
      }), _react["default"].createElement("hr", {
        className: "collaboration-modal__horizontal-line"
      }), _react["default"].createElement(_uiKit.Tabs, {
        updateSelectedTabIndex: this.updateSelectedTabIndex
      }, _react["default"].createElement(_MembersTab["default"], {
        title: "MEMBERS (".concat(filteredMembers.length, ")"),
        members: filteredMembers,
        roles: roles,
        onRemoveMember: onRemoveMember,
        onUpdateMember: onUpdateMember
      }), _react["default"].createElement(_AddUsersTab["default"], {
        title: "ADD USERS",
        onAddMember: onAddMember,
        users: users,
        membersIds: membersIds,
        loading: loading
      }), _react["default"].createElement(_AddTeamsTab["default"], {
        title: "ADD TEAMS",
        onAddMember: onAddMember,
        teams: teams,
        membersIds: membersIds,
        loading: loading
      })))));
    }
  }]), CollaborationModal;
}(_react.Component);

exports["default"] = CollaborationModal;